module.exports = __webpack_public_path__ + "img/guideInfo1.8c9f333e.png";